// extracted by mini-css-extract-plugin
module.exports = {"icon":"customIcon_icon__du5e2"};